export default "__VITE_ASSET__DwwEz6v7__"